'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionCameraEnhance = function ActionCameraEnhance(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M9 3L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2h-3.17L15 3H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-1l1.25-2.75L16 13l-2.75-1.25L12 9l-1.25 2.75L8 13l2.75 1.25z' })
  );
};
ActionCameraEnhance = (0, _pure2.default)(ActionCameraEnhance);
ActionCameraEnhance.displayName = 'ActionCameraEnhance';
ActionCameraEnhance.muiName = 'SvgIcon';

exports.default = ActionCameraEnhance;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/action/camera-enhance.js
// module id = 2489
// module chunks = 0